import { render } from "./BaseNavContent.vue?vue&type=template&id=020c22e8"
import script from "./BaseNavContent.vue?vue&type=script&lang=js"
export * from "./BaseNavContent.vue?vue&type=script&lang=js"

import "./BaseNavContent.vue?vue&type=style&index=0&id=020c22e8&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__